import { render, staticRenderFns } from "./ImageFicheIndex.vue?vue&type=template&id=2a402f64&"
import script from "./ImageFicheIndex.vue?vue&type=script&lang=js&"
export * from "./ImageFicheIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports